<template>
  <div class="orderDetail">
    <!-- 简单订单信息 -->
    <div class="status-number-date" v-if="orderInfo.orderId">
      <div class="status" v-if="orderInfo.orderStatus == 0">
        <img class="icon" :src="picUrl+'qunaer/order/orderStatus_00.png'" alt="" srcset="">
				待审核
      </div>
      <div class="status" v-if="orderInfo.orderStatus == 1">
				<img class="icon" :src="picUrl+'qunaer/order/orderStatus_01.png'" alt="" srcset="">
				已通过
      </div>
      <div class="status" v-if="orderInfo.orderStatus == 2">
				<img class="icon" :src="picUrl+'qunaer/order/orderStatus_02.png'" alt="" srcset="">
				已拒绝
      </div>
      <div class="status" v-if="orderInfo.orderStatus == 3">
				<img class="icon" :src="picUrl+'qunaer/order/orderStatus_03.png'" alt="" srcset="">
				已取消
      </div>
      <div class="number">
        <span class="label">订单编号</span>
        <span class="text">{{orderInfo.orderId}}</span>
      </div>
      <div class="date">
        <span class="label">提交时间</span>
        <span class="text">{{orderInfo.createTime}}</span>
      </div>
    </div>
    <!-- 具体订单信息 -->
    <div class="orderInfo" v-if="orderInfo.orderId">
      <div class="orderInfoTop"></div>
      <div class="name-leave">
        <span class="name van-ellipsis">{{orderInfo.scenicName}}</span>
        <img class="leave" :src="picUrl+'qunaer/scenic/level01.png'" alt="" srcset="" v-if="orderInfo.scenicInfo.scenicType == '3A景区'">
        <img class="leave" :src="picUrl+'qunaer/scenic/level02.png'" alt="" srcset="" v-if="orderInfo.scenicInfo.scenicType == '4A景区'">
        <img class="leave" :src="picUrl+'qunaer/scenic/level03.png'" alt="" srcset="" v-if="orderInfo.scenicInfo.scenicType == '5A景区'">
        <img class="leave" :src="picUrl+'qunaer/scenic/level04.png'" alt="" srcset="" v-if="orderInfo.scenicInfo.scenicType == '主题乐园'">
      </div>
      <img class="line" :src="picUrl+'qunaer/order/line01.png'" alt="">
      <div class="other">
        <div class="address-distance van-multi-ellipsis--l2">
          <span class="address">{{orderInfo.scenicInfo.address}}</span>
          <span class="baseline" v-if="orderInfo.scenicInfo.distance && orderInfo.scenicInfo.address"></span>  
          <span class="distance" v-if="orderInfo.scenicInfo.distance">{{distance}}</span>
        </div>
        <div class="ticket-container">
          <Steps :stepsList="steps" :stepsActive="stepsActive"></Steps>
        </div>
        <van-button plain type="primary" block @click="back">返回上一页</van-button>
      </div>
      <img class="line02" :src="picUrl+'qunaer/order/line02.png'" alt="">
    </div>
  </div>
</template>

<script>
import { Button, Toast } from 'vant'
import Steps from '@/components/steps'
import { setToken, getPicUrl } from '../utils/auth'
import { getUserInfo, getOrderInfo } from '@/api/index'

export default {
  name: 'OrderDetail',
  components: {
		[Button.name]: Button,
		[Toast.name]: Toast,
		Steps
	},
  data() {
    return {
      businessId: '',
      orderId: '',
      userId: '',
      latitude: '',
      longitude: '',
      orderInfo: {},
      ticketContent: '',
      picUrl: getPicUrl(),
      steps: [
        {
          title: '预约已提交，正在处理中',
          desc: '预计在出行前48小时内完成审核。'
        },
        {
          title: '预约已通过',
          desc: '您的预约已受理，请耐心等待。'
        },
        {
          title: '已出票',
          desc: '票务信息已上传。'
        }
      ],
      stepsActive: 0
    }
  },
  created() {
    const that = this
    this.businessId = this.$route.params.businessId
    this.orderId = this.$route.params.orderId
    this.getUserInfo()
    .then(res => {
      if(res.data.code != '200'){
        throw res.data.msg
      }
      if(res.data.code == '200'){
        setToken(res.data.data.token)
        that.userId = res.data.data.userId
        that.getOrderInfo()
      }
    })
    .catch(err => {
      that.$toast(err)
    })
  },
  watch: {
    orderInfo() {
      let m = ''
      const distance = this.orderInfo.scenicInfo.distance
      if(distance/1000>=1){
        m = (distance/1000).toFixed(2)+'km'
      }else{
        m = distance+'m'
      }
      this.distance = m
    }
  },
  methods: {
    // 获取用户信息
		getUserInfo() {
			const { businessId } = this
			return getUserInfo({ businessId })
    },
    // 获取预约详情
    async getOrderInfo() {
      const { latitude, longitude, orderId, userId } = this
      const res = await getOrderInfo({ latitude, longitude, orderId, userId })
      if(res.data.code != '200'){
        this.$toast(res.data.msg)
      }
      if(res.data.code == '200'){
        const orderDeatail = res.data.data
        this.orderInfo = orderDeatail
        this.steps[0]['desc'] = '预约人：' + orderDeatail.orderName + '，' + orderDeatail.appointDay //steps第一阶段信息
					switch (orderDeatail.orderStatus) {
            case 0:
              // 预约信息审核中
              this.stepsActive = 0
              this.steps = [{
                  title: '预约已提交，正在处理中',
                  desc: '预计在出行前48小时内完成审核。'
                },
                {
                  title: '预约已通过',
                  desc: '您的预约已受理，请耐心等待。'
                },
                {
                  title: '已出票',
                  desc: '票务信息已上传。'
                }
              ]
              break;

            case 1:
              //预约通过
              if (!orderDeatail.ticketContent && !orderDeatail.ticketNum && !orderDeatail.qrcodeContent) {
                // 未出票
                this.stepsActive = 1;
                this.steps = [{
                    title: '预约已提交，正在处理中',
                    desc: '预计在出行前48小时内完成审核。'
                  },
                  {
                    title: '预约已通过',
                    desc: '您的预约已受理，请耐心等待。'
                  },
                  {
                    title: '已出票',
                    desc: '票务信息已上传。'
                  }
                ]
              } else {
                //已出票
                this.stepsActive = 2
                let ticket = '预计在出行前48小时内完成审核。'
                
                if (orderDeatail.ticketContent) {
                  ticket = '入园信息：' + this.replaceDetail(orderDeatail.ticketContent)
                }

                if (orderDeatail.ticketNum) {
                  ticket = `门票编码：${orderDeatail.ticketNum}`
                }
                if (orderDeatail.qrcodeContent) {
									ticket = `
									门票二维码：<img src="${this.picUrl}${orderDeatail.qrcodeContent}" />
									<p style="font-size: 12px;text-align: center;">票务信息由<span style="color: #00bc7a;">中青旅</span>平台提供</p>
									`
								}
                // if (orderDeatail.isDistance !== 0) {
                //   ticket = '请在游玩当天景区5公里范围内点击获取票务信息,需打开手机定位功能。'
                // }
                this.steps = [{
                    title: '预约已提交，正在处理中',
                    desc: '预计在出行前48小时内完成审核。'
                  },
                  {
                    title: '预约已通过',
                    desc: '您的预约已受理，请耐心等待。'
                  },
                  {
                    title: '已出票',
                    desc: ticket
                  }
                ]
              }
              break;

            case 2:
              // 客服拒绝预约
              this.stepsActive = 1
              this.steps = [{
                  title: '预约已提交，正在处理中',
                  desc: '预计在出行前48小时内完成审核。'
                },
                {
                  title: '预约已拒绝',
                  desc: orderDeatail.refusedReson
                },
              ]
              break;

            case 3:
              // 取消
              this.stepsActive = 1
              this.steps = [{
                  title: '预约已提交，正在处理中',
                  desc: '预计在出行前48小时内完成审核。'
                },
                {
                  title: '预约已取消',
                  desc: '您的预约已取消，如有疑问，请联系客服。'
                },
              ]
          }
      }
    },
    // 富文本转换
    replaceDetail:function(details){
      if(details!='' && details != null){
        var texts='';//待拼接的内容
        while(details.indexOf('<img')!=-1){//寻找img 循环
          texts+=details.substring('0',details.indexOf('<img')+4);//截取到<img前面的内容
          details = details.substring(details.indexOf('<img')+4);//<img 后面的内容
          if(details.indexOf('style=')!=-1 && details.indexOf('style=')<details.indexOf('>')){
            texts+=details.substring(0,details.indexOf('style="')+7)+"max-width:100%;height:auto;margin:0 auto;";//从 <img 后面的内容 截取到style= 加上自己要加的内容
            details=details.substring(details.indexOf('style="')+7); //style后面的内容拼接
          }else{
            texts+=' style="max-width:100%;height:auto;margin:0 auto;" ';
          }		
        }
        texts+=details;//最后拼接的内容
        return texts
      }else{
        return details 
      }
    },
    // 返回上一页
    back() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.orderDetail {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #F7F7F7;
  overflow-y: auto;
}
/* 订单简单信息 */
.status-number-date {
  padding: 0 45px;
  width: calc(100% - 90px);
  height: 443px;
  font-size: 28px;
  color: #FFF;
  background: linear-gradient(135deg,rgba(82,211,131,1) 0%,rgba(0,188,122,1) 100%);
}
.status-number-date .status {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  padding-top: 52px;
  font-size: 40px;
  font-weight: bold;
}
.status-number-date .status .icon {
  width: 60px;
  height: 60px;
  margin-right: 30px;
}
.status-number-date .number {
  margin-bottom: 20px;
}
.status-number-date .number,
.status-number-date .date {
  height: 40px;
  line-height: 40px;
}
.status-number-date .label {
  margin-right: 30px;
}

/* 具体订单信息 */
.orderInfo {
  position: relative;
  margin: -162px auto 100px auto;
  border-top: 1px solid transparent;
  width: calc(100% - 100px);
  font-size: 0;
}
.orderInfo .orderInfoTop {
  position: absolute;
  top: 0;
  left: -10px;
  border-radius: 16px;
  width: calc(100% + 20px);
  height: 31px;
  background: #00924A;
}
.orderInfo .name-leave {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 15px;
  padding: 40px 40px 0 40px;
  width: calc(100% - 80px);
  height: 50px;
  font-size: 36px;
  font-weight: bold;
  background: #FFF;
}
.orderInfo .name-leave .name {
  flex: 0 1 auto;
}
.orderInfo .name-leave .leave {
  flex: 0 0 auto;
  margin-left: 30px;
  width: 120px;
  height: 40px;
}
.orderInfo .line {
  width: 100%;
  height: 30px;
}
.orderInfo .other {
  padding: 0 40px;
  width: calc(100% - 80px);
  min-height: 500px;
  background: #FFF;
}
.orderInfo .address-distance {
  line-height: 40px;
  font-size: 26px;
}
.orderInfo .address-distance .baseline {
  display: inline-block;
  margin: 0 10px;
  flex: 0 0 auto;
  width: 2px;
  height: 26px;
  background: #DDD;
}
.orderInfo .ticket-container {
  margin-top: 30px;
  margin-bottom: 50px;
  font-size: 28px;
}
.ticket-container .warning {
  margin-bottom: 50px;
  font-size: 23px;
  line-height: 35px;
  color: #999;
}
.orderInfo .ticket-container .reason .label {
  font-weight: bold;
}
.orderInfo .ticket-container .reason .text {
  margin-top: 10px;
  color: #999;
}
.orderInfo .line02 {
  position: absolute;
  left: 0;
  bottom: -30px;
  width: 100%;
  height: 30px;
}
</style>